import { render, staticRenderFns } from "./AffiliateOffers.vue?vue&type=template&id=47164ba8&scoped=true&"
import script from "./AffiliateOffers.vue?vue&type=script&lang=js&"
export * from "./AffiliateOffers.vue?vue&type=script&lang=js&"
import style0 from "./AffiliateOffers.vue?vue&type=style&index=0&id=47164ba8&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47164ba8",
  null
  
)

export default component.exports